import { Flex } from 'components';
import styled from 'styled-components';

export const Wrapper = styled(Flex)`
  min-width: 100%;
  padding: 5px 10px;
  gap: 10px;
  background-color: ${({ theme }) => theme.palette.neutral.light};
`;
